<div class="overlay" [ngClass]="{'show': isOpen}" (click)="close()"></div>
<div class="off-canvas width-450" [ngClass]="{'show': isOpen}">
    <div class="offCanvas__container">
        <div class="offCanvas__contentWrapper">
            <div class="offCanvas__header">
                <div>
                    <h6 class="offCanvas__title">E-Sign Document</h6>
                    <p class="text-xs text-gray-500">Upload your document and add digital signatures</p>
                </div>
                <button class="offCanvas__crossIcon" (click)="close()">
                    <img src="../../../assets/images/user-management/Cross.svg" alt="close" />
                </button>
            </div>
            <div class="offcanvas__content">
                <div class="flex flex-col gap-4">
                    <!-- Upload Document -->
                    <div class="flex flex-col gap-1" *ngIf="!pendingDoc">
                        <label class="text-sm font-light text-[#5f6d7e]">Upload Document <span
                                class="text-[#de7141]">*</span></label>
                        <input #file type="file" class="hidden" (change)="upload($event)" accept=".pdf">
                        <div *ngIf="!uploadedFileName"
                            class="border-2 border-dashed border-orange-300 rounded-lg p-6 sm:p-8 text-center bg-gradient-to-br from-orange-50 to-orange-25 cursor-pointer transition-all hover:border-orange-400"
                            [ngClass]="{'border-orange-500 bg-orange-100': isDragOver}"
                            (click)="triggerFileInputClick()" (dragover)="onDragOver($event)"
                            (dragleave)="onDragLeave($event)" (drop)="onDrop($event)">
                            <div class="flex flex-col items-center gap-3">
                                <div
                                    class="w-12 h-12 bg-white rounded-lg flex items-center justify-center shadow-sm border border-orange-100">
                                    <svg class="w-6 h-6 text-orange-600" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" />
                                    </svg>
                                </div>
                                <div>
                                    <p class="text-sm font-semibold text-gray-800">Drag & drop your document</p>
                                    <p class="text-xs text-gray-500">or click to browse • PDF up to 10MB</p>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="uploadedFileName"
                            class="border-2 border-solid border-orange-300 rounded-lg p-4 bg-gradient-to-r from-orange-50 to-orange-25 flex items-center justify-between cursor-pointer"
                            (click)="triggerFileInputClick()">
                            <div class="flex items-center gap-3 flex-1 min-w-0">
                                <div
                                    class="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm border border-orange-100 flex-shrink-0">
                                    <svg class="w-5 h-5 text-orange-600" fill="currentColor" viewBox="0 0 24 24">
                                        <path
                                            d="M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z" />
                                    </svg>
                                </div>
                                <div class="min-w-0">
                                    <p class="text-sm font-semibold text-gray-800 truncate">{{ uploadedFileName }}</p>
                                    <p class="text-xs text-gray-500">Click to change file</p>
                                </div>
                            </div>
                            <div class="flex-shrink-0 ml-2">
                                <svg class="w-5 h-5 text-teal-600" fill="currentColor" viewBox="0 0 20 20">
                                    <path fill-rule="evenodd"
                                        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                                        clip-rule="evenodd" />
                                </svg>
                            </div>
                        </div>
                        <div *ngIf="uploadErrorMessage" class="text-red-500 text-xs mt-1">
                            {{ uploadErrorMessage }}
                        </div>
                    </div>
                    <!-- Pending Mode: read-only file display -->
                    <div *ngIf="pendingDoc" class="flex flex-col gap-1">
                        <label class="text-sm font-light text-[#5f6d7e]">Document</label>
                        <div class="border-2 border-solid border-orange-300 rounded-lg p-4 bg-gradient-to-r from-orange-50 to-orange-25 flex items-center gap-3">
                            <div class="w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm border border-orange-100 flex-shrink-0">
                                <svg class="w-5 h-5 text-orange-600" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                                    <rect x="4" y="2" width="16" height="20" rx="2"></rect>
                                    <path d="M9 12h6M9 16h4M14 2v4h4"></path>
                                </svg>
                            </div>
                            <div class="min-w-0 flex-1">
                                <p class="text-sm font-semibold text-gray-800 truncate">{{ pendingDoc?.fileName }}</p>
                                <p class="text-xs text-gray-500">Shared document</p>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-col gap-2" *ngIf="!pendingDoc">
                        <label class="text-sm font-light text-[#5f6d7e]">Who needs to sign? <span
                                class="text-[#de7141]">*</span></label>
                        <div class="grid grid-cols-2 gap-2">
                            <button type="button"
                                class="flex items-center gap-2 rounded-lg border-2 px-3 py-2.5 text-left transition-all"
                                [ngClass]="signingMode === 'just-me'
                                    ? 'border-[#de7141] bg-orange-50 text-[#de7141]'
                                    : 'border-gray-200 bg-white text-gray-700 hover:border-orange-200'"
                                (click)="setSigningMode('just-me')">
                                <svg class="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                                    <path
                                        d="M12 12c2.7 0 4.8-2.1 4.8-4.8S14.7 2.4 12 2.4 7.2 4.5 7.2 7.2 9.3 12 12 12zm0 2.4c-3.2 0-9.6 1.6-9.6 4.8v2.4h19.2v-2.4c0-3.2-6.4-4.8-9.6-4.8z" />
                                </svg>
                                <div>
                                    <p class="text-xs font-semibold leading-none">Just me</p>
                                    <p class="text-[10px] text-gray-400 mt-0.5">Self-sign now</p>
                                </div>
                            </button>
                            <button type="button"
                                class="flex items-center gap-2 rounded-lg border-2 px-3 py-2.5 text-left transition-all"
                                [ngClass]="signingMode === 'send-to-others'
                                    ? 'border-[#de7141] bg-orange-50 text-[#de7141]'
                                    : 'border-gray-200 bg-white text-gray-700 hover:border-orange-200'"
                                (click)="setSigningMode('send-to-others')">
                                <svg class="w-4 h-4 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24">
                                    <path
                                        d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z" />
                                </svg>
                                <div>
                                    <p class="text-xs font-semibold leading-none">Send to others</p>
                                    <p class="text-[10px] text-gray-400 mt-0.5">Request signatures</p>
                                </div>
                            </button>
                        </div>
                    </div>
                    <div *ngIf="pendingDoc || signingMode === 'just-me'">
                        <app-input-filed [control]="esignNameControl" [label]="'Signatory Name'" [starIcon]="'*'"
                            [placeholder]="'Enter signatory name'" [type]="'text'"></app-input-filed>
                        <div *ngIf="esignNameControl.invalid && (esignNameControl.dirty || esignNameControl.touched)"
                            class="text-xs text-red-500 font-normal mt-1 h-[16px]">
                            <div *ngIf="esignNameControl.errors?.['required']">
                                Please enter signatory name.
                            </div>
                        </div>
                    </div>
                    <div *ngIf="signingMode === 'send-to-others'" class="flex flex-col gap-2">
                        <app-input-filed [control]="recipientEmailControl" [label]="'Recipient Email'"
                            [starIcon]="'*'" [placeholder]="'Enter recipient email'" [type]="'email'"></app-input-filed>
                        <div *ngIf="recipientEmailControl.invalid && (recipientEmailControl.dirty || recipientEmailControl.touched)"
                            class="text-xs text-red-500 font-normal mt-1 h-[16px]">
                            <div *ngIf="recipientEmailControl.errors?.['required']">
                                Please enter recipient email.
                            </div>
                            <div *ngIf="recipientEmailControl.errors?.['pattern']">
                                Please enter a valid email address.
                            </div>
                        </div>
                    </div>
                    <div *ngIf="signingMode === 'send-to-others'"
                        class="flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 px-4 py-3">
                        <div class="flex flex-col gap-0.5">
                            <span class="text-sm font-medium text-gray-800">Deduct credits</span>
                            <span class="text-xs text-gray-500">
                                {{ deductFromOwner ? 'Credits will be deducted from your account' : 'Credits will be deducted from the recipient\'s account' }}
                            </span>
                        </div>
                        <button type="button"
                            class="relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 focus:outline-none"
                            [ngClass]="deductFromOwner ? 'bg-[#de7141]' : 'bg-gray-300'"
                            (click)="deductFromOwner = !deductFromOwner"
                            [attr.aria-checked]="deductFromOwner"
                            role="switch">
                            <span
                                class="pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200"
                                [ngClass]="deductFromOwner ? 'translate-x-5' : 'translate-x-0'">
                            </span>
                        </button>
                    </div>
                </div>
            </div>
            <div class="offCanvas__footer">
                <app-common-button buttonClass="regularButton" buttonLabel="Cancel"
                    (clickEvent)="close()"></app-common-button>
                <app-common-button buttonClass="smallFilledButton"
                    [buttonLabel]="!pendingDoc && signingMode === 'send-to-others' ? 'Share' : 'eSign'"
                    [disabled]="isSubmitDisabled || shareLoader || pendingLoader"
                    [loadingIcon]="pendingLoader || (!pendingDoc && signingMode === 'send-to-others' && shareLoader)"
                    (clickEvent)="onSubmit()"></app-common-button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="verifyLoader" class="fixed inset-0 bg-white/70 flex items-center justify-center z-[10600]">
    <div class="spinner"></div>
</div>
<app-success-toaster *ngIf="showSuccessToaster" [title]="successMessage"
    (closeToaster)="closeToaster('success')"></app-success-toaster>
<app-error-toaster *ngIf="showErrorToaster" [title]="errorMessage"
    (closeToaster)="closeToaster('error')"></app-error-toaster>